<template>
  <div class="tw-p-2 tw-bg-white tw-w-full tw-border tw-border-solid tw-flex tw-items-center tw-gap-2 tw-border-s-0">
    <router-link :to="{ name: 'pages.dashboard.admin' }"
      class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <icon icon="solar:home-smile-bold-duotone" /> <span class="tw-text-sm">{{ $t("dashboard.sidebar.dashboard")
      }}</span>
    </router-link>
    <span class="tw-text-gray-300">/</span>
    <router-link :to="{ name: 'pages.admin.products' }"
      class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <span class="tw-text-sm">{{ $t("dashboard.sidebar.products")
      }}</span>
    </router-link>
    <span class="tw-text-gray-300">/</span>
    <div>
      <button v-if="!loading" disabled class="tw-text-primary-500 tw-text-xl tw-flex tw-items-center tw-gap-2"><span
          class="tw-text-sm">{{
            product.name }}</span></button>
      <button v-if="loading" disabled class="tw-text-gray-500 tw-text-xl tw-flex tw-items-center tw-gap-2">
        <icon icon="eos-icons:three-dots-loading" />
      </button>

    </div>
  </div>

  <div class="tw-p-2 tw-grid tw-grid-cols-12 tw-gap-2">
    <div class="tw-col-span-12 md:tw-col-span-12 lg:tw-col-span-12">
      <ProductStatusWidget />
    </div>
    <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6">
      <StockStatusWidget />
    </div>
    <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6">
      <ProductPerformanceWidget />
    </div>
    <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6">
      <TopAgentsList />
    </div>
    <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6">
      <TopMarketersList />
    </div>
    <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6">
      <CancellationReasonsWidget />
    </div>
    <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-6">
      <OrderStatusWidget />
    </div>
  </div>
</template>

<script setup>
import { get } from '@/api/products';
import { ref, provide } from 'vue'
import { useRoute } from 'vue-router';
import TopAgentsList from '@/components/dashboard/admin/products/charts/TopAgentsList.vue';
import TopMarketersList from '@/components/dashboard/admin/products/charts/TopMarketersList.vue';
import OrderStatusWidget from '@/components/dashboard/admin/products/charts/OrderStatusWidget.vue';
import ProductStatusWidget from '@/components/dashboard/admin/products/charts/ProductStatusWidget.vue';
import StockStatusWidget from '@/components/dashboard/admin/products/charts/StockStatusWidget.vue';
import ProductPerformanceWidget from '@/components/dashboard/admin/products/charts/ProductPerformanceWidget.vue';
import CancellationReasonsWidget from '@/components/dashboard/admin/products/charts/CancellationReasonsWidget.vue';

const $route = useRoute();
const product = ref({});

const loading = ref(true);

const id = $route.params.id;

provide('product', product);
provide('loading', loading);
provide('id', id);


const fetchProduct = async () => {
  loading.value = true;

  await get(id)
    .then(
      ({ data }) => {
        product.value = data.product;
      },
      error => {
        console.log(error)
      }
    )

  loading.value = false;
}

fetchProduct();

</script>

<style></style>